module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.confirmDeleteUser
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "grey darken-4"
    }
  }, [_vm._v("mdi-delete")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6504ad14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/permissions/components/AgGridButtonRenderer.vue
// module id = 1914
// module chunks = 0